import { AppError } from "../../Types/AppError";

export const SHOW_ERROR = "SHOW_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const showError = (error: AppError) => ({
  type: SHOW_ERROR,
  payload: error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});
